<template>
  <split-pane :min-percent="0" :default-percent="defaultPercent" split="vertical">
    <template slot="paneL">
      <split-pane split="horizontal" :min-percent="0">
        <template slot="paneL">
          <edit-part
            ref="edit_part"
            @runSql="handleRunSql"
            @clear="
              () => {
                $refs.sql_result.handleClear()
              }
            "
          ></edit-part>
        </template>
        <template slot="paneR">
          <sql-result ref="sql_result" style="background: #fff" @tabChange="(val) => handleTabChange(val)"></sql-result>
        </template>
      </split-pane>
    </template>
    <template slot="paneR">
      <div style="height: 100%; background: #fff">
        <markdown
          :noteId="noteId"
          @insert="insertToEditor"
          @edit="editNote"
          ref="note"
          @expendNote="expendNote"
        ></markdown>
      </div>
    </template>
  </split-pane>
</template>
<script>
import SqlResult from '@/views/laboratory/component/SqlResult.vue'
import EditPart from '@/views/laboratory/component/EditPart.vue'
import { SIDEBAR_COLLAPSE } from '@/store/mutation-types'
import Markdown from '@/views/laboratory/component/Markdown.vue'
export default {
  name: 'Console',
  components: { SqlResult, EditPart, Markdown },
  data() {
    return {
      defaultPercent: 55,
      loading: false,
      editMode: false,
      noteId: undefined,
      isMobile: false,
    }
  },
  watch: {
    '$store.state.user.noteId': {
      handler: function (newVal, oldVal) {
        this.noteId = newVal
      },
    },
    '$store.state.app.isMobile': {
      handler: function (newVal, oldVal) {
        this.isMobile = newVal
      },
    },
  },
  mounted() {
    if (localStorage.getItem('CURRENT_NOTE_ID')) {
      this.noteId = localStorage.getItem('CURRENT_NOTE_ID')
    } else {
      this.noteId = '-1'
    }
    if (this.$route.params.sql) {
      this.$nextTick(() => {
        this.$refs.edit_part.code = this.$route.params.sql
        if (this.$route.params.runImmediate) {
          this.$refs.sql_result.handleRunSql(this.$route.params.sql)
        }
      })
    }

    if (this.$route.params.createNote) {
      this.$store.commit(SIDEBAR_COLLAPSE, true)
      this.$refs.note.editMode = true
    }
  },
  methods: {
    editNote(flag) {
      this.$store.commit(SIDEBAR_COLLAPSE, flag)
      this.defaultPercent = flag ? 40 : 55
    },
    expendNote(flag) {
      this.defaultPercent = flag ? 0 : this.$store.getters['collapse'] ? 40 : 55
      if (!flag) {
        this.$refs.edit_part.update()
      }
    },
    // 将文档代码块插入左侧编辑器
    insertToEditor(value, runImmediate = false) {
      this.$refs.edit_part.code = value
      if (runImmediate) {
        this.$refs.sql_result.handleRunSql(value)
      }
    },
    // 运行sql
    handleRunSql(val) {
      this.$refs.sql_result.handleRunSql(val).finally(() => {})
    },
    handleTabChange(sql) {
      this.$refs.edit_part.handleTabChange(sql)
    },
  },
}
</script>
<style lang="less" scoped>
</style>